<template>
        <!--==================== HEADER ====================-->
        <headerr/>

        <!--==================== MAIN ====================-->
        <main class="main">
            <!--==================== HOME ====================-->
            <home/>

            <!--==================== ABOUT ====================-->
            <about/>

            <!--==================== SKILLS ====================-->
            <skills/>

            <!--==================== QUALIFICATION ====================-->
            <qualification/>

            <!--==================== SERVICES ====================-->
            <services/>

            <!--==================== PORTFOLIO ====================-->
            <portfolio/>

            <!--==================== PROJECT IN MIND ====================-->
            <project/>

            <!--==================== TESTIMONIAL ====================-->
            <testimonial/>

            <!--==================== CONTACT ME ====================-->
            <contact/>
        </main>

        <!--==================== FOOTER ====================-->
        <footerr/>
        
        <!--==================== SCROLL TOP ====================-->
        <a href="#" class="scrollup" id="scroll-up">
            <i class="uil uil-arrow-up scrollup__icon"></i>
        </a>
</template>


<script>
import Headerr from '@/components/HeaderrView.vue';
import Home from '@/components/HomeView.vue';
import About from '@/components/AboutView.vue';
import Skills from '@/components/SkillsView.vue';
import Qualification from '@/components/QualificationView.vue';
import Services from '@/components/ServicesView.vue';
import Portfolio from '@/components/PortfolioView.vue';
import Project from '@/components/ProjectView.vue';
import Testimonial from '@/components/TestimonialView.vue';
import Contact from '@/components/ContactView.vue';
import Footerr from '@/components/FooterView.vue';
import { useHead } from '@vueuse/head';

export default {
    components: {Headerr, Home, About, Skills, Qualification, Services, Portfolio, Project, Testimonial, Contact, Footerr},
    name: 'Master',
    setup() {
        useHead({
            title: 'Abdul Mufid | Fullstack Developer',
            meta: [
                { name: 'description', content: 'Portfolio Muhammad Ilham Abdul Mufid – Fullstack Developer & Backend Engineer berpengalaman dalam pengembangan aplikasi web end-to-end, REST API, dan Cloud Deployment.' },
                { name: 'keywords', content: 'Abdul Mufid, Muhammad Ilham Abdul Mufid, Fullstack Developer, Backend Engineer, Web Developer, Node.js, React, Vue.js, Cloud Computing, Affidev' },
                { name: 'author', content: 'Muhammad Ilham Abdul Mufid' },
                { name: 'robots', content: 'index, follow' },
                // Open Graph
                { property: 'og:type', content: 'website' },
                { property: 'og:title', content: 'Abdul Mufid | Fullstack Developer' },
                { property: 'og:description', content: 'Kunjungi portfolio profesional Abdul Mufid, Fullstack Developer spesialis web modern, UI/UX, dan teknologi terbaru.' },
                { property: 'og:url', content: 'https://eabdalmufid.github.io/portfolio' },
                { property: 'og:image', content: 'https://avatars.githubusercontent.com/u/110360966?v=4' },
                { property: 'og:site_name', content: 'Portfolio Abdul Mufid' },
                { property: 'og:locale', content: 'id_ID' },
                // Twitter Card
                { name: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', content: 'Abdul Mufid | Fullstack Developer' },
                { name: 'twitter:description', content: 'Lihat karya dan pengalaman Abdul Mufid di dunia pengembangan web.' },
                { name: 'twitter:image', content: 'https://avatars.githubusercontent.com/u/110360966?v=4' },
            ],
            link: [
                { rel: 'canonical', href: 'https://eabdalmufid.github.io/portfolio' },
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Person',
                        name: 'Muhammad Ilham Abdul Mufid',
                        alternateName: 'Abdul Mufid',
                        url: 'https://eabdalmufid.github.io/portfolio',
                        image: 'https://avatars.githubusercontent.com/u/110360966?v=4',
                        jobTitle: 'Fullstack Developer',
                        worksFor: { '@type': 'Organization', name: 'Affidev' },
                        sameAs: [
                            'https://github.com/eabdalmufid',
                            'https://www.linkedin.com/in/eabdalmufid/',
                            'https://www.instagram.com/eabdlmufid',
                        ],
                    }),
                },
            ],
        });
    },
};
</script>